import { useQuery } from '@tanstack/react-query';

import { IWarehousesParams } from '@app/models/interfaces';
import Api from '@app/services/api';

export const useGetWarehousesQuery = ({ limit, offset }: IWarehousesParams) => {
  return useQuery({
    queryKey: ['getWarehouses', limit, offset],
    queryFn: () => Api.wms.getWarehouses({ limit, offset }),
  });
};
